<template>
  <div class="meetingTimeBar">
    <section class="content poster">
      <header>
        <app-icon class="icon" icon="meeting-time" />
        <h2>Meeting timer</h2>
        <h3 class="descriptionTitle">Using your time well</h3>
        <p class="description">
          Here's how much time you have left for this meeting. You can give yourself more time if you need it. Make sure you allow enough time to end your
          meeting well.
        </p>
      </header>
      <timer-responsive type="meeting" class="timerHolder" />

      <div key="buttons" class="buttons">
        <div id="skillBarControls" class="phaseControls btn-pair">
          <button :class="{ halfButton: iAmModerator }" class="moreTime" key="moreTime" ref="moreTime" @click="handleMoreTime">More Time</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import { useTimeStore } from '@/store/pinia/time';
import { useUsersStore } from '@/store/pinia/users';
import TimerResponsive from '@/components/TimerResponsive.vue';

import AppIcon from '@/components/AppIcon.vue';

const $ee = getCurrentInstance().appContext.config.globalProperties.$ee;
const $meetingmanager = getCurrentInstance().appContext.config.globalProperties.$meetingmanager;

const timeStore = useTimeStore();
const usersStore = useUsersStore();
const { iAmModerator } = storeToRefs(usersStore);

function handleMoreTime() {
  let baseDate = timeStore.meetingOverdue ? new Date() : new Date(timeStore.meetingEnd);
  let newEnd = new Date(baseDate.getTime() + 300000);

  $meetingmanager.updateMeeting({
    ends_on: newEnd.getTime() / 1000,
    trigger: 'meetingTimeSidebar',
  });
  timeStore.setAddingLocalTime(true);
  $ee.emit('nM:addTimeLocal');
}
</script>
<style lang="scss" scoped>
.meetingTimeBar {
  container: --meeting-time-sidebar / size;
  section {
    display: grid;
    gap: 1em;
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(#{rem(170px)}, 1fr) auto;
    align-items: stretch;

    padding: rem(60px) rem(29px) rem(30px) rem(29px);
  }

  header {
    margin: 0 0 auto 0;
    h3,
    p {
      line-height: math.div(17, 14);
      margin-bottom: 0;
    }
  }

  .meeting-time-icon :deep(svg) {
    height: rem(32px);
    width: rem(32px);
    display: block;
  }

  h2 {
    @include type-size(medium);
    font-weight: bold;
    margin: 1em 0 rem(12px) 0;
    line-height: math.div(22, 18);
  }
  h3 {
    font-weight: bold;
  }

  .sidebarTimer {
    margin-bottom: auto;
    padding: rem(18px) 0;
  }

  .buttons {
    width: 100%;
    padding: 0 rem(5px);
    margin: auto 0 0 0;
  }

  :deep(.timerHolder) {
    --timer-bar: var(--c__time-base);
    --timer-base: var(--c__time-base);
  }

  :deep(.phaseControls) {
    --c__button: var(--c__text-loud);
    border-width: 2px;
    height: rem(50px);
  }
}

.smallerTimer {
  display: none;
  align-self: flex-start;
  justify-self: flex-start;
  :deep(.timerPie) {
    color: var(--c__time-ok);
  }
}
@container --container-sidebar-extra (height < 40rem) {
  .meetingTimeBar {
    section {
      padding: rem(30px) rem(29px) rem(30px) rem(29px);
    }
    header {
      h2 {
        font-family: $stack-nowhere;
        text-transform: lowercase;
        @include type-size(large);
        margin-top: 0;
      }
      .icon {
        position: absolute;
        left: 0;
        right: 0;
        opacity: 0;
      }
    }
  }
}

@container --container-sidebar-extra (height < 36rem) {
  .meetingTimeBar {
    header {
      position: relative;
      h2 {
        text-align: center;
        margin: 0;
      }
      p,
      h3 {
        position: absolute;
        left: 0;
        right: 0;
        opacity: 0;
      }
    }
  }
}
</style>
